<template>
  <View gap="lg" direction="column" id="pd-showing-requests">
    <View v-if="!hideHeader" justify="space-between">
      <Text variant="h2" ref="showingRequestsSection">
        Showing requests
        <span v-if="hasShowingRequests">({{ showingRequestsAmount }})</span>
      </Text>
    </View>

    <div class="request-grid" v-if="hasShowingRequests">
      <ShowingCard v-for="showing in pendingShowings" :key="showing.id" :showing="showing" :show-status="false" />
    </div>

    <EmptyState
      v-else
      icon="calendar-check-01"
      color="blue-dust"
      title="What are Showing requests?"
      description="Tallo will handle the back and forth with Renters, and will find the best time that works within your availability. All requests need to be approved and we will display them here."
    />
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { EmptyState, Text, View } from '@tallo/design-system';
import { ShowingCard, useShowingsQuery } from '@tallo/investor/showing';

defineProps<{ hideHeader?: boolean }>();

const route = useRoute();
const propertyId = computed(() => route.params.propertyId as string);

const { data } = useShowingsQuery({ propertyId, onlyWithPendingShowingReqests: true });
const pendingShowings = computed(() => data.value || []);
const showingRequestsAmount = computed(() => pendingShowings.value.length);
const hasShowingRequests = computed(() => showingRequestsAmount.value > 0);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.request-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--t-spacing-md);

  @include mobile {
    grid-template-columns: 1fr;
  }
}
</style>
